import client from './HTTPClient';
import auth from './auth';
import estimateEndpoints from './estimate';
import subscriptionEndpoints from './subscription';

export default {
  auth,
  estimate: estimateEndpoints(client),
  subscription: subscriptionEndpoints(client),
};
